"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppConfig = void 0;
const hwt_student_1 = __importDefault(require("./hwt-student"));
const gss_1 = __importDefault(require("./gss"));
const pli_1 = __importDefault(require("./pli"));
const hwt_educator_1 = __importDefault(require("./hwt-educator"));
const mat_man_educator_1 = __importDefault(require("./mat-man-educator"));
const mat_man_student_1 = __importDefault(require("./mat-man-student"));
const prm_educator_1 = __importDefault(require("./prm-educator"));
const prm_student_1 = __importDefault(require("./prm-student"));
const prekitt_1 = __importDefault(require("./prekitt"));
const student_login_1 = __importDefault(require("./student-login"));
const keyboarding_1 = __importDefault(require("./keyboarding"));
const getAppConfig = (app = process.env.REACT_APP_APP_NAME) => {
    switch (app) {
        case 'hwt-student': {
            return hwt_student_1.default;
        }
        case 'gss': {
            return gss_1.default;
        }
        case 'pli': {
            return pli_1.default;
        }
        case 'hwt-educator': {
            return hwt_educator_1.default;
        }
        case 'mat-man-educator': {
            return mat_man_educator_1.default;
        }
        case 'mat-man-student': {
            return mat_man_student_1.default;
        }
        case 'prekitt': {
            return prekitt_1.default;
        }
        case 'prm-educator': {
            return prm_educator_1.default;
        }
        case 'prm-student': {
            return prm_student_1.default;
        }
        case 'student-login': {
            return student_login_1.default;
        }
        case 'keyboarding': {
            return keyboarding_1.default;
        }
        default: {
            throw new Error(`App <${app}> not supported yet! Did you forget to set the REACT_APP_APP_NAME environment variable?`);
        }
    }
};
exports.getAppConfig = getAppConfig;
